module.exports = __webpack_public_path__ + "static/img/policies.2820f526.png";